export enum Roles {
    Administrator = 'Administrator',
    User = 'User',
}
